import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';

import { COUPON_TYPE_LABEL, COUPON_STATUS } from '../constants/index';
import componentUtils from '../utils/index';

const { getGiftEventName, Describe } = componentUtils;
const { createUniqueId } = common;

const couponListBId = createUniqueId();
const operateBtnId = createUniqueId();
const btnIdBeforeRecv = createUniqueId();
const btnIdAfterRecv = createUniqueId();

const COMPONENT_ID = 'waimai_d7uy8htt';
const SUB_COMPONENT_COUPON_ID = 'waimai_kcj7eomr';
const SUB_COMPONENT_USE_ID = 'waimai_24fvbc5s';
const SUB_COMPONENT_RECEIVE_ALL_ID = 'waimai_1pwpf6rn';

const describeCouponListB = new Describe('CouponListB', COMPONENT_ID);
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);
const describeReceiveAll = new Describe('ReceiveAll', SUB_COMPONENT_RECEIVE_ALL_ID);
const describeUse = new Describe('Use', SUB_COMPONENT_USE_ID);

describeCouponListB.setSubComponent('Coupon', describeCoupon);
describeCouponListB.setSubComponent('ReceiveAll', describeReceiveAll);
describeCouponListB.setSubComponent('Use', describeUse);

// 使用按钮点击
const btnUseMC = 'b_waimai_24fvbc5s_mc';
// 一键领取按钮点击
const btnReceiveMC = 'b_waimai_1pwpf6rn_mc';
// 券点击
const CouponMC = 'b_waimai_kcj7eomr_mc';
// 模块展示
const CouponListBMV = 'b_waimai_d7uy8htt_mv';

let propsCache = {};

const CouponListB = (props) => {
    propsCache = props;
    const {
        title = '',
        giftInfoList = [],
        ignoreCommonCoupon = false,
        btnCustomStyle = '',
    } = propsCache || {};
    const { btnNameBeforeRecv = '一键领取', btnNameAfterRecv = '立即下单' } = propsCache || {};
    const { onCouponClick, onBatchRecvClick, onBatchUseClick, oadLX } = propsCache || {};

    // 忽略显示通用红包
    if (ignoreCommonCoupon) {
        let index = -1;
        giftInfoList.some((item, i) => {
            if ( item.giftInfo && item.giftInfo.type === 2 ) {// 通用红包type为2
                index = i;
                return true;
            }
        });
        if (index > -1) {
            giftInfoList.splice(index, 1);
        }
    }

    giftInfoList.forEach((poiInfo) => {
        if (poiInfo.giftInfo) {
            const { gift_id: giftId } = poiInfo.giftInfo;
            const eventName = getGiftEventName(giftId);
            eventBus.$onceOn(eventName, (newStatus) => {
                // 单个券领取成功
            });
        }
    });
    // 过滤出未领取的红包
    const newCouponInfos = giftInfoList.filter(
        (item) => item.giftInfo && item.giftInfo.status === COUPON_STATUS.STATUS_NEW,
    );
    // 获取红包id集合
    const giftIds = newCouponInfos.map((item) => item.giftInfo.gift_id);

    const data = {
        couponListBId,
        btnCustomStyle,
        title,
        giftInfoList,
        couponLabel: COUPON_TYPE_LABEL,
        operateBtnId,
        btnIdBeforeRecv,
        btnNameBeforeRecv,
        btnIdAfterRecv,
        btnNameAfterRecv,
        hasRecv: giftIds.length === 0,
    };
    const events = {
        handleCouponClick(index) {
            onCouponClick && onCouponClick(giftInfoList[index], index);
            oadLX && oadLX.mc(CouponMC);
        },
        async handleBatchRecvClick() {
            if (onBatchRecvClick) {
                const result = await onBatchRecvClick(giftIds);
                if (result) {
                    dom.$id(btnIdBeforeRecv).style.display = 'none';
                    dom.$id(btnIdAfterRecv).style.display = 'flex';
                }
            }
            oadLX && oadLX.mc(btnReceiveMC);
        },
        handleBatchUseClick() {
            onBatchUseClick && onBatchUseClick();
            oadLX && oadLX.mc(btnUseMC);
        },
    };
    oadLX && oadLX.mv(CouponListBMV);
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

eventBus.$onceOn('CouponListB-refresh', (props) => {
    propsCache = { ...propsCache, ...props };
    const container = dom.$id(couponListBId);
    const newComp = CouponListB(propsCache);
    container.outerHTML = newComp;
});

function changeCouponListBBtnStatus(status) {
    const btn = dom.$id(btnIdBeforeRecv);
    if (btn) {
        if (status === 0) {
            //未领取
            dom.$id(btnIdBeforeRecv).style.display = 'flex';
            dom.$id(btnIdAfterRecv).style.display = 'none';
        }
        if (status === 1) {
            //已领取
            dom.$id(btnIdBeforeRecv).style.display = 'none';
            dom.$id(btnIdAfterRecv).style.display = 'flex';
        }
    }
}

CouponListB.changeCouponListBBtnStatus = changeCouponListBBtnStatus;
CouponListB.describe = describeCouponListB;

export default CouponListB;
